import { Chart as ChartJS, ChartOptions } from 'chart.js';
import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { formatToShortString } from '../../../../utils/FormatValue';

export interface DoughnutItem {
  name: string;
  quantity: number;
  color: string;
}

interface Props {
  subTitle: string;
  items: DoughnutItem[];
}

export const DoughnutLegendLines: React.FC<Props> = ({ subTitle, items }) => {
  const [adjustedItems, setAdjustedItems] = useState(items.map((item) => ({ ...item })));

  useEffect(() => {
    setAdjustedItems(items.map((item) => ({ ...item })));
  }, [items, subTitle]);

  interface ExtendedChartOptions extends ChartOptions<'doughnut'> {
    pluginTitle?: string;
    pluginSubTitle?: string;
  }

  const options: ExtendedChartOptions = {
    plugins: {
      tooltip: {
        //callbacks: {
        // label: (tooltipItem) => {
        //   const value = formatToShortString(tooltipItem.raw as number); // TooltipItem's `raw` property contains the value
        //   const suffix = shortForm; // Add your suffix here
        //   return ` ${value} ${suffix}`;
        // },
        //},
      },
      legend: {
        display: false,
      },
    },
    pluginTitle: sumQuantity(adjustedItems),
    pluginSubTitle: subTitle,
  };
  const chartData = {
    labels: adjustedItems.map(({ name }) => name),
    datasets: [
      {
        data: adjustedItems.map(({ quantity }) => quantity),
        backgroundColor: adjustedItems.map(({ color }) => color),
        borderWidth: 2,
        radius: '80%',
        cutout: '75%',
      },
    ],
  };

  const plugins = [
    {
      id: 'customCenterTextPlugin',
      beforeDraw(chart: ChartJS) {
        const updatedTitle = (chart.config.options as ExtendedChartOptions).pluginTitle || '';
        const updatedSubTitle = (chart.config.options as ExtendedChartOptions).pluginSubTitle || '';
        const width = chart.width!;
        const height = chart.height!;
        const ctx = chart.ctx;

        ctx.restore();
        const fontSize = 1.5;
        ctx.font = `${fontSize}rem sans-serif`;
        ctx.textBaseline = 'middle';

        const sumTextX = Math.round((width - ctx.measureText(updatedTitle).width) / 2);
        const sumTextY = height / 2.25 - fontSize / 2;
        ctx.fillStyle = '#000000';
        ctx.fillText(updatedTitle, sumTextX, sumTextY);
        const mainTextX = Math.round((width - ctx.measureText(updatedSubTitle).width) / 2);
        const mainTextY = height / 1.8 + fontSize / 2;
        ctx.fillStyle = '#9F9F9F';
        ctx.fillText(updatedSubTitle, mainTextX, mainTextY);

        ctx.save();
      },
    },
  ];

  return <Doughnut data={chartData} options={options} plugins={plugins} />;
};

const sumQuantity = (_items: { quantity: number }[]): string => {
  return formatToShortString(_items.reduce((acc, { quantity }) => acc + quantity, 0));
};
